/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'automation-menu.empty-state.image.alt': 'Ikona pustej listy automatyzacji',
  'automation-menu.empty-state.learn-more.link': 'Dowiedz się więcej o ręcznym wyzwalaniu',
  'automation-menu.modal.empty.automations.admin.description':
    'Użyj ręcznego wyzwalania, aby wypełnić menu opcji do wyboru, które każdy — albo wskazane przez Ciebie osoby — może zastosować jako automatyzację jednym kliknięciem.',
  'automation-menu.modal.empty.automations.user.description':
    'Administratorzy nie skonfigurowali jeszcze żadnych ręcznie wyzwalanych automatyzacji.',
  'automation-menu.modal.error.description': 'Ładowanie trwa za długo. Spróbuj odświeżyć stronę.',
  'automation-menu.modal.error.image.alt': 'Ikona błędu',
  'automation-menu.modal.footer.automate-button': 'Automatyzuj',
  'automation-menu.modal.footer.cancel-button': 'Anuluj',
  'automation-menu.modal.footer.get-started-button': 'Utwórz automatyzację',
  'automation-menu.modal.footer.ok-button': 'OK',
  'automation-menu.modal.header.icon.label': 'Ikona nagłówka okna modalnego automatyzacji',
  'automation-menu.success-state.message': 'Automatyzacja jest w toku',
  'fabric.linking.access_exists_description': 'Poproś o dostęp, aby wyświetlić tę treść z witryny {hostname}.',
  'fabric.linking.actions': 'Akcje',
  'fabric.linking.add_account': 'Dodaj konto',
  'fabric.linking.ai_summarize': 'Podsumuj',
  'fabric.linking.ai_summarized': 'Podsumowane przez Atlassian Intelligence',
  'fabric.linking.ai_summarized_abbreviation': 'Podsumowane przez AI',
  'fabric.linking.ai_summarized_info': 'Jakość informacji może się różnić. <a>Dowiedz się więcej</a>',
  'fabric.linking.ai_summarized_info_short': 'Jakość treści może być zmienna',
  'fabric.linking.ai_summarizing': 'Atlassian Intelligence wykonuje swoją pracę…',
  'fabric.linking.ai_summary_action': 'Użyj AI do podsumowań',
  'fabric.linking.ai_summary_action_description':
    'Podsumuj zawartość tego łącza za pomocą funkcji Atlassian Intelligence.',
  'fabric.linking.ai_summary_error_acceptable_use_violation':
    'Nie możemy pokazać wyników tego podsumowania, ponieważ jest to sprzeczne z <a>zasadami dopuszczalnego użytkowania Atlassian</a>.',
  'fabric.linking.ai_summary_error_exceeding_context_length_error':
    'Atlassian Intelligence nie może teraz wygenerować podsumowania, ponieważ jest zbyt dużo treści do podsumowania.',
  'fabric.linking.ai_summary_error_generic':
    'Atlassian Intelligence (AI) nie odpowiada. Spróbuj ponownie później lub <a>sprawdź status AI</a>.',
  'fabric.linking.ai_summary_error_hipaa_content_detected':
    'Atlassian Intelligence nie może przetworzyć Twojego żądania, ponieważ treść zawiera łącza do zawartości podlegających ograniczeniom przepisów HIPAA.',
  'fabric.linking.assigned_to': 'Przypisano do {context}',
  'fabric.linking.automation-action.confluence.page.modal.description':
    'Zastosuj automatyzacje do <b>{name}</b>.{br}Opcje dostępne do wyboru są kontrolowane przez administratorów Confluence i przestrzeni.',
  'fabric.linking.automation-action.confluence.page.modal.title': 'Automatyzacje stron',
  'fabric.linking.automation-action.icon.label': 'Ikona automatyzacji',
  'fabric.linking.automation-action.title': 'Wyświetl reguły automatyzacji',
  'fabric.linking.automation-action.tooltip': 'Wybierz regułę automatyzacja do uruchomienia',
  'fabric.linking.beta': 'Wersja beta',
  'fabric.linking.cancel': 'Anuluj',
  'fabric.linking.cannot_connect': 'Nie można nawiązać połączenia. Spróbuj ponownie.',
  'fabric.linking.cannot_find_link': 'Nie można znaleźć łącza',
  'fabric.linking.check_this_link': 'Sprawdź to łącze',
  'fabric.linking.click_to_join': 'Zacznij korzystać z {context}',
  'fabric.linking.click_to_join_description': 'Uzyskano zatwierdzenie, więc możesz od razu dołączyć do {context}.',
  'fabric.linking.close': 'Zamknij',
  'fabric.linking.connect_account_description': 'Otworzymy nową stronę, aby pomóc Ci połączyć swoje konto {name}',
  'fabric.linking.connect_link_account': 'Połącz podgląd',
  'fabric.linking.connect_link_account_card_view': 'Połącz',
  'fabric.linking.connect_link_account_card_view_description':
    'Aby wyświetlić podgląd tego łącza, połącz swoje konto {context}.',
  'fabric.linking.connect_link_account_card_view_name': 'Połącz konto {context}',
  'fabric.linking.connect_to': 'Połącz z {name}',
  'fabric.linking.connect_unauthorised_account_action': 'Połącz z {context}',
  'fabric.linking.connect_unauthorised_account_description':
    'Połącz swoje konto {context}, aby współpracować w różnych produktach Atlassian.',
  'fabric.linking.connect_unauthorised_account_description_no_provider':
    'Połącz swoje konto, aby współpracować w różnych produktach Atlassian.',
  'fabric.linking.continue': 'Kontynuuj',
  'fabric.linking.copied_summary_action_description': 'Podsumowanie zostało skopiowane do schowka',
  'fabric.linking.copied_url_to_clipboard': 'Skopiowano!',
  'fabric.linking.copy_summary_action': 'Kopiuj podsumowanie',
  'fabric.linking.copy_summary_action_description': 'Kopiuj podsumowanie',
  'fabric.linking.copy_url_to_clipboard': 'Kopiuj łącze',
  'fabric.linking.couldnt_load_link': 'Z nieznanego powodu nie udało się wczytać tego łącza.',
  'fabric.linking.create_on_absolute': 'Utworzono {context}',
  'fabric.linking.create_on_relative': 'Utworzono {context}',
  'fabric.linking.created_by': 'Autor: {context}',
  'fabric.linking.delete': 'Usuń',
  'fabric.linking.direct_access': 'Dołącz teraz',
  'fabric.linking.direct_access_description':
    'Twój zespół używa produktu {product} do współpracy – zacznij z niego korzystać już teraz!',
  'fabric.linking.direct_access_title': 'Dołącz do {product}, aby wyświetlić tę treść',
  'fabric.linking.download': 'Pobierz',
  'fabric.linking.download_description': 'Pobierz ten plik do swojej pamięci lokalnej',
  'fabric.linking.download_file': 'Pobierz plik',
  'fabric.linking.edit': 'Edytuj',
  'fabric.linking.follow': 'Obserwuj',
  'fabric.linking.follow_goal': 'Obserwuj cel',
  'fabric.linking.follow_goal_description': 'Obserwuj ten cel, aby otrzymywać powiadomienia o aktualizacjach',
  'fabric.linking.follow_goal_error':
    'Podczas próby zaobserwowania celu wystąpił błąd. Sprawdź połączenie internetowe lub odśwież stronę i spróbuj ponownie.',
  'fabric.linking.follow_project': 'Obserwuj projekt',
  'fabric.linking.follow_project_description': 'Obserwuj, aby otrzymywać powiadomienia o tym projekcie',
  'fabric.linking.follow_project_error':
    'Podczas próby zaobserwowania projektu wystąpił błąd. Sprawdź połączenie internetowe lub odśwież stronę i spróbuj ponownie.',
  'fabric.linking.forbidden_access': 'Dostęp zabroniony',
  'fabric.linking.forbidden_description':
    'Skontaktuj się z administratorem, aby poprosić o dostęp do witryny {hostname}.',
  'fabric.linking.forbidden_title': 'Nie masz dostępu do tej treści',
  'fabric.linking.generic_error_message': 'Wystąpił błąd',
  'fabric.linking.go_back': 'Wstecz',
  'fabric.linking.invalid_permissions': 'Treść objęta ograniczeniami',
  'fabric.linking.invalid_permissions_description':
    'Musisz poprosić o dostęp lub spróbować innego konta, aby zobaczyć ten podgląd.',
  'fabric.linking.join_to_view': 'Dołącz do {context}, aby wyświetlić to zgłoszenie',
  'fabric.linking.join_to_view-issue-term-refresh': 'Dołącz do {context}, aby wyświetlić to zgłoszenie',
  'fabric.linking.learn_more_about_connecting_account': 'Dowiedz się więcej o łączeniu konta z  produktami Atlassian.',
  'fabric.linking.learn_more_about_smart_links': 'Dowiedz się więcej o inteligentnych łączach.',
  'fabric.linking.link_safety_warning_message':
    'Łącze {unsafeLinkText} przeniesie Cię do innej witryny, <a>actual link here</a>',
  'fabric.linking.loading': 'Ładowanie...',
  'fabric.linking.modified_on_absolute': 'Zaktualizowano {context}',
  'fabric.linking.modified_on_relative': 'Zaktualizowano {context}',
  'fabric.linking.more_actions': 'Więcej czynności',
  'fabric.linking.more_information_about_this_work_item': 'Więcej informacji o tym zgłoszeniu',
  'fabric.linking.no_access_title': 'Dołącz do {product}, aby wyświetlić tę treść',
  'fabric.linking.not_found_description': 'Strona nie istnieje lub mogła ulec zmianie po dodaniu tego łącza.',
  'fabric.linking.not_found_title': 'Nie można wyświetlić tej strony {product}',
  'fabric.linking.open_issue_in_jira': 'Otwórz zgłoszenie w systemie Jira',
  'fabric.linking.open_issue_in_jira-issue-term-refresh': 'Otwórz zgłoszenie w systemie Jira',
  'fabric.linking.open_link_in_a_new_tab': 'Otwórz łącze na nowej karcie',
  'fabric.linking.owned_by': 'Właściciel: {context}',
  'fabric.linking.pending_request': 'Twój wniosek o dostęp oczekuje na rozpatrzenie',
  'fabric.linking.preview_close': 'Zamknij podgląd',
  'fabric.linking.preview_description': 'Otwórz podgląd tego łącza na pełnym ekranie',
  'fabric.linking.preview_improved': 'Otwórz podgląd',
  'fabric.linking.preview_max_size': 'Wyświetl na pełnym ekranie',
  'fabric.linking.preview_min_size': 'Zamknij widok pełnoekranowy',
  'fabric.linking.priority_blocker': 'Bloker',
  'fabric.linking.priority_critical': 'Krytyczny',
  'fabric.linking.priority_high': 'Wysoki',
  'fabric.linking.priority_highest': 'Najwyższy',
  'fabric.linking.priority_low': 'Niski',
  'fabric.linking.priority_lowest': 'Najniższy',
  'fabric.linking.priority_major': 'Poważny',
  'fabric.linking.priority_medium': 'Średni',
  'fabric.linking.priority_minor': 'Drobny',
  'fabric.linking.priority_trivial': 'Trywialny',
  'fabric.linking.priority_undefined': 'Nie zdefiniowano',
  'fabric.linking.read_time': '{context} min czytania',
  'fabric.linking.related': 'Powiązane',
  'fabric.linking.related_links_found_in': 'Znaleziono w',
  'fabric.linking.related_links_includes_links_to': 'Obejmuje łącza do',
  'fabric.linking.related_links_includes_links_to_v2': 'Obejmuje łącza do',
  'fabric.linking.related_links_modal_error_description':
    'Sprawdź połączenie internetowe lub odśwież stronę, aby spróbować ponownie.',
  'fabric.linking.related_links_modal_error_header': 'Coś poszło nie tak',
  'fabric.linking.related_links_modal_error_message':
    'Podczas ładowania ostatnio używanych łączy wystąpił problem. Sprawdź połączenie lub odśwież stronę, aby spróbować ponownie.',
  'fabric.linking.related_links_modal_error_title': 'Wystąpił problem podczas ładowania powiązanych łączy',
  'fabric.linking.related_links_modal_title': 'Ostatnio używane łącza',
  'fabric.linking.related_links_modal_title_v2': 'Powiązane łącza',
  'fabric.linking.related_links_modal_unavailable_description':
    'Stale sprawdzamy i dodajemy powiązane łącza do zaktualizowanych stron lub innych typów treści.',
  'fabric.linking.related_links_modal_unavailable_header': 'Brak ostatnio używanych łączy',
  'fabric.linking.related_links_modal_unavailable_message':
    'Nie znaleziono żadnych łączy do wyświetlenia tutaj. Stale sprawdzamy i dodajemy najnowsze łącza do zaktualizowanych stron lub innych typów treści.',
  'fabric.linking.related_links_modal_unavailable_title': 'Nie znaleziono żadnych powiązanych łączy',
  'fabric.linking.related_links_not_found': 'Nie znaleziono żadnych łączy do wyświetlenia tutaj.',
  'fabric.linking.related_links_view_related_links': 'Wyświetl powiązane łącza',
  'fabric.linking.related_links_view_related_urls': 'Wyświetl ostatnio używane łącza',
  'fabric.linking.request_access': 'Poproś o dostęp',
  'fabric.linking.request_access_description':
    'Twój zespół używa {product} do współpracy. Poproś administratora o dostęp.',
  'fabric.linking.request_access_pending': 'Oczekiwanie na zatwierdzenie',
  'fabric.linking.request_access_pending_description':
    'Twoja prośba o dostęp do witryny {hostname} oczekuje na zatwierdzenie przez administratora.',
  'fabric.linking.request_access_pending_title': 'Oczekiwanie na dostęp do {product}',
  'fabric.linking.request_access_to_view': 'Poproś o dostęp do {context}, aby wyświetlić to zgłoszenie',
  'fabric.linking.request_access_to_view-issue-term-refresh':
    'Poproś o dostęp do {context}, aby wyświetlić to zgłoszenie',
  'fabric.linking.request_denied': 'Twój wniosek o dostęp został odrzucony',
  'fabric.linking.request_denied_description':
    'Administrator nie zatwierdził Twojej prośby o dostęp do stron {product} w witrynie {hostname}.',
  'fabric.linking.restricted_link': 'Łącze z ograniczeniami. Spróbuj z innego konta.',
  'fabric.linking.retry': 'Spróbuj ponownie',
  'fabric.linking.save': 'Zapisz',
  'fabric.linking.sent_on_absolute': 'Wysłano {context}',
  'fabric.linking.sent_on_relative': 'Wysłano {context}',
  'fabric.linking.srclink': 'Wyświetl w',
  'fabric.linking.srclinkunknown': 'Wyświetl oryginał',
  'fabric.linking.status_change_load_error': 'Nie można załadować statusów ani zmian statusów',
  'fabric.linking.status_change_permission_error': 'Nie masz uprawnień do zmiany statusu tego zgłoszenia.',
  'fabric.linking.status_change_permission_error-issue-term-refresh':
    'Nie masz uprawnień do zmiany statusu tego zgłoszenia.',
  'fabric.linking.status_change_update_error': 'Nie można zaktualizować statusu',
  'fabric.linking.try_again': 'Spróbuj ponownie',
  'fabric.linking.try_another_account': 'Spróbuj użyć innego konta',
  'fabric.linking.unassigned': 'Nie przypisano',
  'fabric.linking.unauthorised_account_description':
    'Próbujesz wyświetlić podgląd łącza do strony prywatnej {context}. Zalecamy, aby sprawdzić adres URL lub skontaktować się z właścicielem strony.',
  'fabric.linking.unauthorised_account_description_no_provider':
    'Próbujesz wyświetlić podgląd łącza do strony prywatnej. Zalecamy, aby sprawdzić adres URL lub skontaktować się z właścicielem strony.',
  'fabric.linking.unauthorised_account_name': 'Nie można wyświetlić stron prywatnych z {context}',
  'fabric.linking.unauthorised_account_name_no_provider': 'Nie można wyświetlić stron prywatnych',
  'fabric.linking.unfollow': 'Przestań obserwować',
  'fabric.linking.unfollow_goal': 'Przestań obserwować cel',
  'fabric.linking.unfollow_goal_description': 'Przestań obserwować, aby nie dostawać więcej powiadomień o tym celu',
  'fabric.linking.unfollow_goal_error':
    'Podczas próby zaprzestania obserwacji celu wystąpił błąd. Sprawdź połączenie internetowe lub odśwież stronę i spróbuj ponownie.',
  'fabric.linking.unfollow_project': 'Przestań obserwować projekt',
  'fabric.linking.unfollow_project_description': 'Przestań obserwować, aby nie dostawać więcej powiadomień o projekcie',
  'fabric.linking.unfollow_project_error':
    'Podczas próby zaprzestania obserwowania projektu wystąpił błąd. Sprawdź połączenie internetowe lub odśwież stronę i spróbuj ponownie.',
  'fabric.linking.unlink_account': 'Odłącz konto',
  'fabric.linking.updated_by': 'Autor modyfikacji: {context}',
  'fabric.linking.view': 'Wyświetl',
};
